import * as React from "react";
import { Button, Dropdown, MenuProps, Space } from "antd";
import { DownOutlined, SisternodeOutlined } from "@ant-design/icons";
import { GroupType } from "src/types/ZGroup";
import { TreeActionsPort } from "src/pages/ManagementPage/objects/ports";
import { getGroupTypeIcon } from "../../utils/itemIcons";

interface PropsAddGroupItem {
  store: TreeActionsPort;
  disabled?: boolean;
  buttonId?: string;
}

export const AddGroupItem: React.FC<PropsAddGroupItem> = (props) => {
  const { store, disabled, buttonId } = props;

  const menuProps: MenuProps = {
    items: [
      {
        key: "attr",
        label: "Добавить атрибут",
        icon: <SisternodeOutlined />,
        onClick: () => store.safeAddAttr(),
      },
      {
        type: "divider",
      },
      {
        key: "groups",
        type: "group",
        label: "Добавить группу атрибутов",
        children: [
          {
            key: "mnenoGroup",
            label: "Мнемоническую",
            icon: getGroupTypeIcon(GroupType.Mnemonic),
            onClick: () => store.safeAddGroup(GroupType.Mnemonic),
          },
          {
            key: "dictiGroup",
            label: "На основе справочника",
            icon: getGroupTypeIcon(GroupType.ByDictionary),
            onClick: () => store.safeAddGroup(GroupType.ByDictionary),
          },
        ],
      },
    ],
  };

  return (
    <Dropdown menu={menuProps} disabled={disabled}>
      <Button id={buttonId}>
        <Space>
          Добавить
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
